var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "expand",
    transform: "translate(9212.827 -15084)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2008",
    "data-name": "Rectangle 2008",
    width: 50,
    height: 50,
    transform: "translate(-9212.827 15084)",
    fill: "#2a2247",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_11",
    "data-name": "Union 11",
    d: "M26.916,30.814l3.9-3.9a1.409,1.409,0,0,1,2.4,1v0a1.409,1.409,0,0,1-.413.994L28.9,32.8a1.406,1.406,0,1,1-1.987-1.99Zm-13.252,0L30.82,13.665a1.408,1.408,0,1,1,1.991,1.99L15.654,32.8a1.407,1.407,0,1,1-1.989-1.99Zm-12.255,2.4a1.407,1.407,0,0,1-.994-2.4L30.82.415a1.408,1.408,0,1,1,1.991,1.99L2.421,32.8a1.412,1.412,0,0,1-.994.413Z",
    transform: "translate(-9201.23 15095.762)",
    fill: "#686295",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.16a2f0785d05e7b97b896a433957e8d4.svg";
export { ForwardRef as ReactComponent };